/**
 * These are the paper sizes supported by PDF documents. They are the most commonly used. The arrays are
 * [width, height] in millimeters.
 *
 * This information was extracted from ::PDF::Core::PageGeometry::SIZES in Ruby.
 */
window.PaperSizes = {
  "4A0": [1682.0, 2378.0],
  "2A0": [1189.0, 1682.0],
  "A0": [841.0, 1189.0],
  "A1": [594.0, 841.0],
  "A2": [420.0, 594.0],
  "A3": [297.0, 420.0],
  "A4": [210.0, 297.0],
  "A5": [148.0, 210.0],
  "A6": [105.0, 148.0],
  "A7": [74.0, 105.0],
  "A8": [52.0, 74.0],
  "A9": [37.0, 52.0],
  "A10": [26.0, 37.0],
  "B0": [1000.0, 1414.0],
  "B1": [707.0, 1000.0],
  "B2": [500.0, 707.0],
  "B3": [353.0, 500.0],
  "B4": [250.0, 353.0],
  "B5": [176.0, 250.0],
  "B6": [125.0, 176.0],
  "B7": [88.0, 125.0],
  "B8": [62.0, 88.0],
  "B9": [44.0, 62.0],
  "B10": [31.0, 44.0],
  "C0": [917.0, 1297.0],
  "C1": [648.0, 917.0],
  "C2": [458.0, 648.0],
  "C3": [324.0, 458.0],
  "C4": [229.0, 324.0],
  "C5": [162.0, 229.0],
  "C6": [114.0, 162.0],
  "C7": [81.0, 114.0],
  "C8": [57.0, 81.0],
  "C9": [40.0, 57.0],
  "C10": [28.0, 40.0],
  "RA0": [860.0, 1220.0],
  "RA1": [610.0, 860.0],
  "RA2": [430.0, 610.0],
  "RA3": [305.0, 430.0],
  "RA4": [215.0, 305.0],
  "SRA0": [900.0, 1280.0],
  "SRA1": [640.0, 900.0],
  "SRA2": [450.0, 640.0],
  "SRA3": [320.0, 450.0],
  "SRA4": [225.0, 320.0],
  "EXECUTIVE": [184.1, 266.7],
  "FOLIO": [215.9, 330.2],
  "LEGAL": [215.9, 355.6],
  "LETTER": [215.9, 279.4],
  "TABLOID": [279.4, 431.8]
};
